/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSidebarData } from "./sidebardata";
import api from "../../api/axios";
import { encrypt } from "../../utils/crypto";
import { useRole } from "../../context/RoleContext";
import { companyID } from "../../auth";

const Sidebar = () => {
  const { permissions, loading: roleLoading } = useRole();
  const location = useLocation();
  const pathname = location.pathname;
  const companyName = localStorage.getItem("companyName")?.toLowerCase();
  const roleId = localStorage.getItem("employee_role");
  const loginEmployeeId = localStorage.getItem("employeeID");
  const encryptedEmployeeId = encrypt(loginEmployeeId);
  const SidebarData = useSidebarData();
  const company_id = companyID();
  // const userRole = "Employee"; // Get user role from localStorage or state

  const [sidebarData, setSidebarData] = useState([]);
  const [isSidebarExpanded, setSidebarExpanded] = useState(false);
  const [isMouseOverSidebar, setMouseOverSidebar] = useState(false);
  const [submenuDrop, setSubmenudrop] = useState(false);
  const [isSideMenu, setSideMenu] = useState("");
  const [level2Menu, setLevel2Menu] = useState("");
  const [level3Menu, setLevel3Menu] = useState("");
  const [isSideMenunew, setSideMenuNew] = useState("dashboard");
  const [userRole, setUserRole] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (roleId) {
      api
        .get(`employeeRole/${roleId}`)
        .then((res) => setUserRole(res?.data[0].role_name))
        .catch((err) => console.log("Employee role error : ", err))
        .finally(() => {});
    }
  }, []);

  useEffect(() => {
    if (
      isMouseOverSidebar &&
      document.body.classList.contains("mini-sidebar")
    ) {
      document.body.classList.add("expand-menu");
      return;
    }
    document.body.classList.remove("expand-menu");
  }, [isMouseOverSidebar]);

  const filterMenuByRole = (menuData, userRole) => {
    return menuData
      .filter((section) => {
        // Filter out sections based on user role
        if (section.accessTo && section.accessTo.length > 0) {
          return section.accessTo.includes(userRole);
        }
        return true; // If no accessTo are specified, show the section
      })
      .map((section) => ({
        ...section,
        menu: section.menu
          .filter((menuItem) => {
            // Filter out menu items based on user role
            if (menuItem.accessTo && menuItem.accessTo.length > 0) {
              return menuItem.accessTo.includes(userRole);
            }
            return true; // If no accessTo are specified, show the menu item
          })
          .map((menuItem) => ({
            ...menuItem,
            subMenus: menuItem.subMenus
              ? menuItem.subMenus.filter((subMenu) => {
                  // Filter out sub-menus based on user role
                  if (subMenu.accessTo && subMenu.accessTo.length > 0) {
                    return subMenu.accessTo.includes(userRole);
                  }
                  return true; // If no accessTo are specified, show the sub-menu
                })
              : [],
          })),
      }));
  };

function filterSidebarByPermissions(sidebarData, permissionData, company_id) {
  const permissionRoutes = permissionData?.pages
    ? Object.keys(permissionData.pages)
    : [];

    // if(permissionRoutes?.length ==0)  navigate('/error-403')
  const normalizeRoute = (route) => {
    return route ? (route.startsWith("/") ? route.slice(1) : route) : "";
  };

  const hasPermission = (route) => {
    if (!route) return false;
    return permissionRoutes.some((permRoute) => {
      if (permRoute.includes("/:")) {
        const baseRoute = permRoute.split("/:")[0];
        return normalizeRoute(route).startsWith(baseRoute);
      }
      return normalizeRoute(route) === permRoute;
    });
  };

  const filterMenus = (menus) => {
    if (!menus || menus.length === 0) return [];

    return menus
      .map((menu) => {
        let filteredSubMenus = [];

        // Handle submenus recursively
        if (menu.subMenus && menu.subMenus.length > 0) {
          filteredSubMenus = filterMenus(menu.subMenus).map((sm) => ({
            menuValue: sm.menuValue,
            route: sm.route,
            accessTo: sm.accessTo,
          }));
        }

        // Include menu if either it has permission or submenus that are allowed
        if (hasPermission(menu.route) || filteredSubMenus.length > 0) {
          const filteredMenu = {
            menuValue: menu.menuValue,
            hasSubRoute: menu.hasSubRoute || false,
            showSubRoute: menu.showSubRoute || false,
            route: menu.route,
            icon: menu.icon,
          };

          if (filteredSubMenus.length > 0) {
            filteredMenu.subMenus = filteredSubMenus;
          }

          return filteredMenu;
        }

        return null;
      })
      .filter(Boolean);
  };

  // ✅ Main filtering
  let filteredSidebar = sidebarData
    .map((section) => {
      const filteredMenu = filterMenus(section.menu);
      if (filteredMenu.length === 0) return null;

      return {
        ...section,
        menu: filteredMenu,
      };
    })
    .filter(Boolean);

  // ✅ If company_id = 1, inject CRM routes into existing CRM section
  if (company_id == 1 && roleId ==1 ) {
    filteredSidebar = sidebarData.map((section) => {
      if (section.tittle?.toLowerCase() === "crm") {
        // Find CRM menu if it exists
        const crmMenus = [...section.menu];

        const extraMenus = [
          // {
          //   menuValue: "Send Mail Campaign",
          //   hasSubRoute: false,
          //   showSubRoute: false,
          //   route: "/send-mail-for-campaign",
          //   icon: "la la-envelope",
          // },
          // {
          //   menuValue: "Companies",
          //   hasSubRoute: false,
          //   showSubRoute: false,
          //   route: "/companies",
          //   icon: "la la-building",
          // },
        ];

        // Avoid duplicates — only push if not already there
        extraMenus.forEach((extra) => {
          const alreadyExists = crmMenus.some(
            (m) => m.route === extra.route
          );
          if (!alreadyExists) crmMenus.push(extra);
        });

        return {
          ...section,
          menu: crmMenus,
        };
      }

      return section;
    });
  }

  return filteredSidebar;
}




  useEffect(() => {
    const storedCompany = localStorage?.getItem("companyName");
    const storedCompanyName = storedCompany
      ?.toLowerCase()
      ?.replace(/\s+/g, "-");
    const filteredData =   permissions ? filterSidebarByPermissions(SidebarData , permissions , company_id)  :[]
    // Update sidebar data based on user role
    const updatedSidebarData =   filteredData ? filteredData.map((section) => {
      const updatedSection = { ...section };
      if (updatedSection.menu) {
        updatedSection.menu = section.menu.map((menuItem) => {
          const updatedMenuItem = { ...menuItem };
          if (updatedMenuItem.subMenus) {
            updatedMenuItem.subMenus = menuItem.subMenus.map((subMenu) => ({
              ...subMenu,
              route: `/${storedCompanyName}${subMenu.route}`,
            }));
          } else {
            updatedMenuItem.route = `/${storedCompanyName}${menuItem.route}`;
          }
          return updatedMenuItem;
        });
      }
      return updatedSection;
    }) : [];
    setSidebarData(updatedSidebarData);
    //
    // setSidebarData();
  }, [userRole]);

  const handleMouseEnter = () => {
    setMouseOverSidebar(true);
  };

  const handleMouseLeave = () => {
    setMouseOverSidebar(false);
  };

  const { t } = useTranslation();
  const [submenuTrue, setSubmenuTrue] = useState("");

  useEffect(()=>{
    if(!permissions){ 
      navigate('/error-403')
    }
  },[])

  const expandSubMenus = (menu) => {
    if (submenuTrue === menu.menuValue) {
      setSubmenuTrue("");
    } else {
      setSubmenuTrue(menu.menuValue);
    }
    sessionStorage.setItem("menuValue", menu.menuValue);
    const updatedAdminSidebar = sidebarData.map((section) => {
      const updatedSection = { ...section };
      
      updatedSection.menu = section.menu.map((menuItem) =>
        menu.menuValue != menuItem.menuValue
          ? {
              ...menuItem,
              showSubRoute: false,
            }
          : {
              ...menuItem,
              showSubRoute: !menu.showSubRoute,
            }
      );
      return updatedSection;
    });
    setSidebarData(updatedAdminSidebar);
  };

  const arrowDrop = () => {
    console.log("arro edrop clicked......");
    setSubmenudrop(!submenuDrop);
  };

  const toggleSidebar = (value) => {
    setSideMenu(value);
    setSideMenuNew(value);
  };

  const toggleLvelTwo = (value) => {
    setLevel2Menu(value);
  };

  const toggleLevelThree = (value) => {
    setLevel3Menu(value);
  };

  const MenuMore = () => {
    document.getElementById("more-menu-hidden").classList.toggle("hidden");
  };

  const sidebarRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      window.innerWidth <= 890 &&
      sidebarRef.current &&
      !sidebarRef.current.contains(event.target)
    ) {
      document.body.classList.remove("slide-nav"); // Close sidebar if clicked outside on mobile screen
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleNavLink = () => {
    if (window.innerWidth <= 890) {
      document.body.classList.remove("slide-nav"); // Close sidebar on nav link click if on mobile screen
    }
  };


  return (
    <div
      className={`sidebar ${isSidebarExpanded ? "" : "hidden"}`}
      id="sidebar"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={sidebarRef}
    >
      <div className="sidebar-inner slimscroll" style={{ overflow: false }}>
        <div id="sidebar-menu" className="sidebar-menu">
          <nav className="greedys sidebar-horizantal" id="horizantal-sidebar">
            
            <button
              className="viewmoremenu"
              id="more-menu"
              onClick={() => MenuMore()}
            >
              More Menu
            </button>
          </nav>
          <Scrollbars
            autoHide={false}
            autoHideTimeout={1000}
            autoHideDuration={200}
            autoHeight
            autoHeightMin={0}
            autoHeightMax="100vh"
            thumbMinSize={30}
            universal={false}
            hideTracksWhenNotNeeded={true}
          >
            <ul className="sidebar-vertical" id="veritical-sidebar">
              {sidebarData.map((mainTittle, index) => {
                return (
                  <>
                    <li className="menu-title" key={index + 1}>
                      <span>{t(mainTittle.tittle)}</span>
                      {mainTittle?.tittle === "CRM" ? (
                        <small class="newly-added-features">New</small>
                      ) : (
                        ""
                      )}
                    </li>
                    {mainTittle.menu.map((menu, menuIndex) => {
                      return (
                        <>
                          {menu.hasSubRoute === false ? (
                            <li
                              key={menuIndex + 1}
                              className={pathname == menu.route ? "active" : ""}
                            >
                              <Link to={menu.route} onClick={handleNavLink}>
                                {/* {menu.icon} */}
                                <i className={menu?.icon} />
                                <span>{t(menu.menuValue)}</span>
                              </Link>
                            </li>
                          ) : (
                            <li className="submenu">
                              <a
                                // to="#"
                                onClick={() => expandSubMenus(menu)}
                                className={menu.showSubRoute ? "subdrop" : ""}
                              >
                                <i className={menu?.icon} />
                                <span
                                  className={
                                    menu?.menuValue == "Employees"
                                      ? "noti-dot"
                                      : ""
                                  }
                                >
                                  {t(menu.menuValue)}
                                </span>
                                <span className="menu-arrow"></span>
                              </a>
                              <ul
                                style={{
                                  display:
                                    menu.showSubRoute &&
                                    submenuTrue === menu?.menuValue
                                      ? "block"
                                      : "none",
                                }}
                              >
                                {menu.subMenus.map((subMenus, subMenu) => {
                                  // console.log(' subMenus : ',`${subMenus.route}`,' subMenu : ',subMenu )
                                  return (
                                    <>
                                      {/* {console.log(subMenus?.showMenuRoute)} */}
                                      {subMenus?.showMenuRoute === true &&
                                      submenuTrue ? (
                                        <li key={subMenu + 1}>
                                          <Link
                                            to={subMenus.route}
                                            className={
                                              submenuDrop ? "subdrop" : ""
                                            }
                                            onClick={() => {
                                              arrowDrop();
                                              handleNavLink();
                                            }}
                                          >
                                            {t(subMenus.menuValue)}
                                            <span className="menu-arrow"></span>
                                          </Link>

                                          <ul
                                            style={{
                                              display: submenuDrop
                                                ? "block"
                                                : "none",
                                            }}
                                          >
                                            {subMenus?.subMenusValues?.map(
                                              (value, index) => {
                                                // console.log("value, : ",value);

                                                return (
                                                  <li key={index}>
                                                    <span>
                                                      <Link
                                                        to={value.route}
                                                        onClick={handleNavLink}
                                                      >
                                                        <span>
                                                          {t(value.menuValue)}{" "}
                                                        </span>
                                                      </Link>
                                                    </span>
                                                  </li>
                                                );
                                              }
                                            )}
                                          </ul>
                                        </li>
                                      ) : (
                                        <li key={subMenu + 1}>
                                          <Link
                                            to={`${subMenus.route}`}
                                            onClick={handleNavLink}
                                            className={
                                              pathname == subMenus?.route
                                                ? "active"
                                                : ""
                                            }
                                          >
                                            {t(subMenus.menuValue)}
                                          </Link>

                                          <ul>
                                            {subMenus?.subMenusValues?.map(
                                              (value, index) => {
                                                return (
                                                  <li key={index}>
                                                    <Link
                                                      to={value.route}
                                                      onClick={handleNavLink}
                                                      className={
                                                        pathname == value?.route
                                                          ? "active"
                                                          : ""
                                                      }
                                                    >
                                                      {t(value.menuValue)}
                                                    </Link>
                                                  </li>
                                                );
                                              }
                                            )}
                                          </ul>
                                        </li>
                                      )}
                                    </>
                                  );
                                })}
                              </ul>
                            </li>
                          )}
                        </>
                      );
                    })}
                  </>
                );
              })}
            </ul>
          </Scrollbars>
        </div>
      </div>

    </div>
  );
};

export default Sidebar;
